module.exports = __webpack_public_path__ + "img/thankyou_roop.0c3492dd.gif";